var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 51.362,
    height: 41,
    viewBox: "0 0 51.362 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_192",
    x: 0,
    y: 18.536,
    width: 23.362,
    height: 22.464,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4cabd3",
    floodOpacity: 0.639
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_192-2",
    x: 28,
    y: 3.536,
    width: 23.362,
    height: 22.464,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4cabd3",
    floodOpacity: 0.639
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_193",
    x: 28.021,
    y: 0,
    width: 19.239,
    height: 16.885,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4cabd3",
    floodOpacity: 0.639
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_193-2",
    x: 4.102,
    y: 15,
    width: 19.239,
    height: 16.885,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4cabd3",
    floodOpacity: 0.639
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_194",
    x: 14.138,
    y: 6.75,
    width: 22.431,
    height: 27.928,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4cabd3",
    floodOpacity: 0.639
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_125",
    "data-name": "Groupe 125",
    transform: "translate(4.5 15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -15)",
    filter: "url(#Trac\\xE9_192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_192-3",
    "data-name": "Trac\\xE9 192",
    d: "M-225.893,57.5h-5.983c-.494,0-.626.131-.626.625,0,.689-.005,1.379,0,2.068a.7.7,0,0,1-.411.732.693.693,0,0,1-.8-.2q-2.683-2.525-5.37-5.046a.676.676,0,0,1,.009-1.1q.911-.861,1.827-1.718c.059-.055.121-.108.175-.167a.438.438,0,0,0,.018-.631.435.435,0,0,0-.63-.017c-.193.169-.376.349-.564.524-.487.457-.975.911-1.459,1.371a1.563,1.563,0,0,0,0,2.385q2.706,2.549,5.421,5.089a1.5,1.5,0,0,0,1.744.32,1.507,1.507,0,0,0,.936-1.486c0-.608,0-1.216,0-1.856h5.678",
    transform: "translate(244.76 -33.39)",
    fill: "#4cabd3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -15)",
    filter: "url(#Trac\\xE9_192-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_192-4",
    "data-name": "Trac\\xE9 192",
    d: "M-240.255,57.5h5.983c.494,0,.626.131.626.625,0,.689.005,1.379,0,2.068a.7.7,0,0,0,.411.732.693.693,0,0,0,.8-.2q2.683-2.525,5.37-5.046a.676.676,0,0,0-.009-1.1q-.911-.861-1.827-1.718c-.059-.055-.121-.108-.175-.167a.438.438,0,0,1-.018-.631.435.435,0,0,1,.63-.017c.193.169.376.349.564.524.487.457.975.911,1.459,1.371a1.563,1.563,0,0,1,0,2.385q-2.706,2.549-5.421,5.089a1.5,1.5,0,0,1-1.744.32,1.507,1.507,0,0,1-.936-1.486c0-.608,0-1.216,0-1.856h-5.678",
    transform: "translate(272.75 -48.39)",
    fill: "#4cabd3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -15)",
    filter: "url(#Trac\\xE9_193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_193-3",
    "data-name": "Trac\\xE9 193",
    d: "M-240.089,27.554h5.687v-.241c0-.543,0-1.085,0-1.628a1.5,1.5,0,0,1,.946-1.479,1.5,1.5,0,0,1,1.726.317q.838.779,1.667,1.567a.761.761,0,0,1,.181.243.43.43,0,0,1-.173.52.437.437,0,0,1-.58-.076q-.845-.787-1.685-1.58a.689.689,0,0,0-.637-.22.664.664,0,0,0-.544.72c0,.7,0,1.408,0,2.112,0,.51-.128.637-.637.637h-5.917",
    transform: "translate(272.61 -24.06)",
    fill: "#4cabd3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -15)",
    filter: "url(#Trac\\xE9_193-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_193-4",
    "data-name": "Trac\\xE9 193",
    d: "M-229.85,27.554h-5.687v-.241c0-.543,0-1.085,0-1.628a1.5,1.5,0,0,0-.946-1.479,1.5,1.5,0,0,0-1.726.317q-.838.779-1.667,1.567a.761.761,0,0,0-.181.243.43.43,0,0,0,.173.52.437.437,0,0,0,.58-.076q.845-.787,1.685-1.58a.689.689,0,0,1,.637-.22.664.664,0,0,1,.544.72c0,.7,0,1.408,0,2.112,0,.51.128.637.637.637h5.917",
    transform: "translate(248.69 -9.06)",
    fill: "#4cabd3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -15)",
    filter: "url(#Trac\\xE9_194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_194-2",
    "data-name": "Trac\\xE9 194",
    d: "M-236.8,222.418v-2.589c-.475,0-.975,0-1.474,0-.548,0-.86-.243-.86-.647s.3-.634.866-.637c.473,0,.949-.027,1.419.008.371.028.53-.108.675-.449a7.256,7.256,0,0,1,5.7-4.61,6.681,6.681,0,0,1,4.145.608c.494.242.664.576.5.961s-.567.477-1.088.241a5.951,5.951,0,0,0-7.871,2.874,3.843,3.843,0,0,0-.128.366h6.791a3.663,3.663,0,0,1,.391,0c.371.04.69.176.686.61,0,.417-.286.6-.672.63-.13.012-.261,0-.392,0h-7.266v2.625h7.179a2.976,2.976,0,0,1,.488.017c.35.058.612.291.54.629a1.291,1.291,0,0,1-.517.61c-.105.081-.315.031-.478.031h-6.8a2.615,2.615,0,0,0,.111.336,6.017,6.017,0,0,0,7.72,2.935c.091-.036.178-.081.271-.111a.664.664,0,0,1,.9.347.611.611,0,0,1-.358.887,10.475,10.475,0,0,1-2.477.692,7.251,7.251,0,0,1-7.45-4.67.553.553,0,0,0-.637-.423c-.5.026-1.012.014-1.518,0-.487-.009-.81-.288-.8-.672s.29-.6.788-.612C-237.871,222.413-237.335,222.418-236.8,222.418Z",
    transform: "translate(257.83 -206.64)",
    fill: "#4cabd3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIconBlue);
export default __webpack_public_path__ + "static/media/money-icon-blue.24e25ea57485b725a2bfaae796ae5110.svg";
export { ForwardRef as ReactComponent };